import * as React from "react";
import Modal from "web-com/modal";
import Carousel, {CarouselItem} from "myshubhlife-component/Carousel";
import {CSSProperties} from "react";

interface IProps {
	onClose: (fieldName: string) => void;
	imagesList: string[];
	fieldName: string;
}
const imageStyle: CSSProperties = {
	width: "100%",
	height: "100%",
	objectFit: "cover",
};
const ImageCarousel = ({onClose, imagesList, fieldName}: IProps) => {
	return (
		<div className="kyp-container">
			<Modal active>
				<div className="kyp-close-button" onClick={() => onClose(fieldName)}>&times;</div>
				<div className="kyp-image-container">
					<Carousel>
						{
							imagesList.length > 0 && imagesList.map((item, index) => {
								return(
									<CarouselItem height={425} key={index}>
										<img src={item} alt={"slide-image"} style={imageStyle}/>
									</CarouselItem>
								);
							})
						}
					</Carousel>
				</div>
			</Modal>
		</div>
	);
};

export default ImageCarousel;
